import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";


class CampagneSMSService {
  //Afficher List CampagneSMSs
  AfficherListCampagneSMS(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/getAll/" + idUser);
  }

  //Afficher List Objectifs
  AfficherListObjectifs() {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/getObjectifs");
  }

  //Afficher List Types
  AfficherListTypes() {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/getTypes");
  }

  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion() {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/getCanalDiffusions");
  }

  //Afficher List Statut
  AfficherListStatus() {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/getStatus");
  }

  // Obtenir la liste des ID de photos dans une CampagneSMS
  getCampagneSMSPhotosId(id) {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/ListImages/" + id, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  // Afficher une image par son ID
  showImage(imageId) {
    return api
      .get(UtilsUrl.marketingURL() + "/campagneSMS/showImage/" + imageId, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const arrayBufferView = new Uint8Array(response.data);
        const blob = new Blob([arrayBufferView], {
          type: response.headers["content-type"],
        });
        const imageUrl = URL.createObjectURL(blob);
        return imageUrl;
      });
  }

  //ajouter CampagneSMS
  /*  ajouterCampagneSMS(nouvelleCampagneSMS, clientIds) {
    return api.post(
      UtilsUrl.marketingURL()  + "/Add?clientIds=" + clientIds,
      nouvelleCampagneSMS
    );
  } */
  ajouterCampagneSMS(nouvelleCampagneSMS, clientIds, file) {
    const formData = new FormData();
    formData.append("idUser", getCurrentUserId());

    formData.append("campagneSMS", JSON.stringify(nouvelleCampagneSMS));
    formData.append("clientIds", clientIds);
    formData.append("file", file);
    return api.post(UtilsUrl.marketingURL() + "/campagneSMS/Add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  //mettreAJour CampagneSMS
  mettreAJourCampagneSMS(updatedCampagneSMS, clientIds, CampagneSMSId) {
    return api.put(
      UtilsUrl.marketingURL() +
      "/campagneSMS/update/" +
      CampagneSMSId +
      "?clientIds=" +
      clientIds,
      updatedCampagneSMS
    );
  }

  //supprimer CampagneSMS
  supprimerCampagneSMS(CampagneSMSId) {
    return api.put(UtilsUrl.marketingURL() + "/campagneSMS/delete/" + CampagneSMSId, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  //get CampagneSMS By ID
  getCampagneSMSByID(CampagneSMSId) {
    return api.get(UtilsUrl.marketingURL() + "/campagneSMS/get/" + CampagneSMSId, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  //filtre
  //filtre
  getCampagneSMSByFiltre(nom, statut, debutDate, finDate) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/campagneSMS/filtre?nom=" +
      nom +
      "&statut=" +
      statut +
      "&debutDate=" +
      debutDate +
      "&finDate=" +
      finDate
    );
  }

  //CSV Methodes
  ImporterCSV(file) {
    return api.post(UtilsUrl.marketingURL() + "/campagneSMS/importcsv", file);
  }

  Exportcsv(nom, canalDiffusion, type, debutDate, finDate) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/campagneSMS/exportcsv?nom=" +
      nom +
      "&type=" +
      type +
      "&canalDiffusion=" +
      canalDiffusion +
      "&debutDate=" +
      debutDate +
      "&finDate=" +
      finDate,
      {
        responseType: "blob",
      }
    );
  }
}

export default new CampagneSMSService();
